/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */
/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

import { getBoxShadow } from '../../../color-palette-ramps/get-box-shadow';

import { BaseTokenButtonStyle } from './base-token-button';
import type { ColorTokenCategoryProps } from './color';

export const Elevation = (props: ColorTokenCategoryProps): React.JSX.Element => {
	const { children, value } = props;

	return (
		<BaseTokenButtonStyle
			css={[
				{
					backgroundColor: token('elevation.surface'),
					color: token('color.text'),
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					boxShadow: getBoxShadow(value),
					outline: `1px solid ${token('color.border')}`,
					'&:hover, &:focus': {
						backgroundColor: token('elevation.surface.hovered'),
					},
					'&:active': {
						backgroundColor: token('elevation.surface.pressed'),
					},
				},
			]}
		>
			{children}
		</BaseTokenButtonStyle>
	);
};
